import React from 'react';

const Gradient = () => {
  return (
    <div className="gradient">
      <div className="gradient-orange"></div>
      <div className="gradient-ellow"></div>
    </div>
  );
};

export default Gradient;
